/**
 * Extracts Storyblok preview parameters from URL search params and formats them for API requests
 * @param searchParams - URLSearchParams object from window.location.search
 * @returns Formatted query string with Storyblok parameters (e.g., "&_storyblok_tk[token]=foo&_storyblok_tk[timestamp]=bar")
 */
export function getStoryblokQueryParams(searchParams: URLSearchParams): string {
	const storyblokParams = [
		'_storyblok_tk[token]',
		'_storyblok_tk[timestamp]',
		'_storyblok_tk[space_id]',
	];

	return storyblokParams
		.filter((param) => searchParams.has(param))
		.map((param) => `&${param}=${searchParams.get(param)}`)
		.join('');
}
